export const microsoftIntegrationURL = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'
      + '?client_id=e2810e39-0334-4088-80d4-bb1f693efc51&response_type=code'
      + '&redirect_uri=https%3A%2F%2Fdigger-v2.digtective.com%2Fmicrosoft'
      + '&scope=openid%20offline_access%20https%3A%2F%2Fads.microsoft.com%2Fmsads.manage&state=12345'
      + '&response_mode=query';

export const hubspotIntegrationUrl = 'https://app-eu1.hubspot.com/oauth/authorize?'
    + 'client_id=26f95496-c09f-4569-9ea8-f0971cdebfca'
    + '&redirect_uri=https://digger-v2.digtective.com/hubspot'
    + '&scope=forms%20crm.objects.contacts.read'
    + '%20crm.objects.companies.read'
    + '%20crm.objects.deals.read';

export const facebookIntegrationUrl = 'https://www.facebook.com/v18.0/dialog/oauth?'
    + 'client_id=118806125480870'
    + '&redirect_uri=https://digger-v2.digtective.com/facebook'
    + '&scope=ads_management%2Cads_read%2Cread_insights';

export const shopifyIntegrationUrl = (shop: string, state: string) => `https://${shop}.myshopify.com/admin/oauth/authorize?`
    + 'client_id=d287f7f262c6b6284241dc77fa4db58b'
    + '&scope=read_products,write_products,write_orders,read_orders&'
    + `redirect_uri=https://digger-v2.digtective.com/shopify&state=${state}`;

export const salesforceIntegrationUrl = 'https://login.salesforce.com/services/oauth2/authorize?'
    + 'client_id=3MVG9PwZx9R6_UrcGj0VrbXkpT9x73NFew.cWxz7cjPY8nlRe_8KziBF9w09DIvH7ppjQNszLsfzISDuJnILk'
    + '&redirect_uri=https://digger-v2.digtective.com/salesforce'
    + '&response_type=code&state=7pj4mfk6a473o69or7knlu09j3';

export const tiktokIntegrationUrl = 'https://www.tiktok.com/v2/auth/authorize/'
    + '?client_key=sbawg2f4wg869ln2gd'
    + '&response_type=code&scope=user.info.basic,user.info.profile,user.info.stats'
    + `&redirect_uri=${import.meta.env.VITE_TIKTOK_REDIRECT_URI ?? ''}`
    + '&state=290ade5f3fbde8220bb81ba5111f7148808fc1e747b66a26837e35a2bf32be26';

export const mailchimpIntegrationUrl = 'https://login.mailchimp.com/oauth2/authorize?'
    + 'response_type=code'
    + `&client_id=${encodeURIComponent(import.meta.env.VITE_MAILCHIMP_CLIENT_ID)}`
    + `&redirect_uri=${encodeURIComponent(import.meta.env.VITE_MAILCHIMP_REDIRECT_URI)}`
    + `&state=${encodeURIComponent('random_state_token')}`;

export const snapchatIntegrationUrl = 'https://accounts.snapchat.com/login/oauth2/authorize\n'
    + '?client_id=49bd762a-9bac-4197-9191-246f445c03ba'
    + '&redirect_uri=https://digger-v2.digtective.com/snapchat'
    + '&response_type=code'
    + '&scope=snapchat-marketing-api snapchat-offline-conversions-api snapchat-profile-api';
